const USER_TYPE_OPTIONS = ['agence', 'model', 'chatter'];
const ADMIN_ROLES = ['admin', 'super_admin', 'superadmin'];

const base64UrlDecode = (segment) => {
  if (!segment) {
    return null;
  }

  let base64 = segment.replace(/-/g, '+').replace(/_/g, '/');
  while (base64.length % 4 !== 0) {
    base64 += '=';
  }

  const hasAtob = typeof window !== 'undefined' && typeof window.atob === 'function';
  const hasBuffer = typeof Buffer !== 'undefined';

  try {
    if (hasAtob) {
      return window.atob(base64);
    }

    if (hasBuffer) {
      return Buffer.from(base64, 'base64').toString('utf-8');
    }
  } catch (error) {
    console.error('JWT base64 decoding error', error);
    return null;
  }

  return null;
};

export const decodeJwt = (token) => {
  if (!token || typeof token !== 'string') {
    return null;
  }

  const parts = token.split('.');
  if (parts.length < 2) {
    return null;
  }

  try {
    const decodedPayload = base64UrlDecode(parts[1]);
    if (!decodedPayload) {
      return null;
    }

    return JSON.parse(decodedPayload);
  } catch (error) {
    console.error('JWT decode error', error);
    return null;
  }
};

export const getUserTypeFromJwt = (token) => {
  const payload = decodeJwt(token);
  const userType = payload?.userType;

  if (USER_TYPE_OPTIONS.includes(userType)) {
    return userType;
  }

  return null;
};

export const formatUserTypeLabel = (userType) => {
  switch (userType) {
    case 'agence':
      return 'Agence';
    case 'model':
      return 'Modèle';
    case 'chatter':
      return 'Chatter';
    default:
      return null;
  }
};

export const isAdminPayload = (payload) => {
  if (!payload || typeof payload !== 'object') {
    return false;
  }

  const role = payload.role || payload.type || payload.userRole || payload.userType;
  const roles = Array.isArray(payload.roles) ? payload.roles : [];
  const adminPermissions = Array.isArray(payload.adminPermissions)
    ? payload.adminPermissions
    : Array.isArray(payload.admin_permissions)
      ? payload.admin_permissions
      : [];
  const permissions = Array.isArray(payload.permissions) ? payload.permissions : [];

  return (
    payload.admin === true ||
    payload.isAdmin === true ||
    payload.is_admin === true ||
    payload.superAdmin === true ||
    payload.is_super_admin === true ||
    ADMIN_ROLES.includes(role) ||
    roles.some((item) => ADMIN_ROLES.includes(item)) ||
    adminPermissions.length > 0 ||
    permissions.some((item) => typeof item === 'string' && item.toLowerCase().includes('admin'))
  );
};

export const isAdminFromJwt = (token) => isAdminPayload(decodeJwt(token));

export { USER_TYPE_OPTIONS };
